import { Alert, Box } from "@mui/material"

export const Notice = ({ children,text, type, onClose }) => {
    return (
        <Box sx={{ position: 'fixed', right: 20, top: 80, zIndex: 20 }}>
            <Alert icon={children} severity={type || "success"} onClose={onClose}>
                {text}
            </Alert>
        </Box>
    )
}